module.exports = __webpack_public_path__ + "static/media/Ubuntu-Light.c9d68f61.ttf";